import { useState } from 'react';
import { councilSearchHelp } from '../../lib/councilLinks';

export default function CouncilSearchHelp({ app, proData = null, url, color, accent }) {
  const help = councilSearchHelp(app, url, proData);
  const [copyState, setCopyState] = useState({ reference: '', message: '' });
  if (!help) return null;

  const copyReference = async () => {
    try {
      await navigator.clipboard.writeText(help.reference);
      setCopyState({ reference: help.reference, message: 'Reference copied' });
    } catch {
      setCopyState({ reference: help.reference, message: 'Could not copy. Select the reference above to copy it.' });
    }
  };

  return <div style={{ color, fontSize: 13, lineHeight: 1.5, margin: '8px 0 16px' }} onClick={event => event.stopPropagation()}>
    <p style={{ margin: 0 }}>{help.message}</p>
    {help.reference && <button type="button" onClick={copyReference} style={{ color: accent || color, background: 'none', border: 'none', padding: '8px 0', minHeight: 44, font: 'inherit', cursor: 'pointer', textDecoration: 'underline' }}>Copy reference</button>}
    <span role="status" style={{ display: 'block' }}>{copyState.reference === help.reference ? copyState.message : ''}</span>
  </div>;
}
